export default __webpack_public_path__ + "static/media/ax.afc5abc1.svg";